import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link } from 'react-router-dom';
import './App.css'; // Ensure this file exists if you have global styles

// Auth Pages
import Login from './Auth/pages/Login';
import ResetPassword from './Auth/pages/ResetPassword'; // Import the new ResetPassword page

// Main Application Pages
import Dashboard from './Dashboard/Dashboard';

// Admin Panel Pages
import AssignAppsPage from '../src/AdminPanel/AssignAppsPage';

// --- Helper Functions (Consider moving to a utils/auth.js file) ---

// Checks if a user is authenticated (has token and user details)
const isAuthenticated = () => {
    const token = localStorage.getItem('authToken');
    const userDetails = localStorage.getItem('loggedInUserDetails');
    return token && userDetails;
};

// Helper to check if the authenticated user is SUPER_ADMIN
const isUserSuperAdmin = () => {
    if (!isAuthenticated()) return false;
    const storedUserDetailsString = localStorage.getItem('loggedInUserDetails');
    if (!storedUserDetailsString) return false;
    try {
        const userDetails = JSON.parse(storedUserDetailsString);
        const roleName = userDetails.role?.name || userDetails.role;
        return roleName && roleName.toUpperCase() === 'SUPER_ADMIN';
    } catch (e) {
        console.error("Error parsing userDetails for SUPER_ADMIN check:", e);
        return false;
    }
};

// --- Protected Route Components (Consider moving to a components/auth/ folder) ---

// General Protected Route: Redirects to login if not authenticated
const ProtectedRoute = ({ children }) => {
    if (!isAuthenticated()) {
        return <Navigate to="/login" replace />;
    }
    return children;
};

// Super Admin Protected Route: Redirects to dashboard if not SUPER_ADMIN
const SuperAdminRoute = ({ children }) => {
    if (!isUserSuperAdmin()) {
        return <Navigate to="/dashboard" replace />;
    }
    return children;
};


function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Public Routes - Accessible to everyone */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Login />} />
          
          {/* ========================================================== */}
          {/*          THIS IS THE ROUTE THAT WAS MISSING              */}
          {/* ========================================================== */}
          <Route path="/reset-password" element={<ResetPassword />} />
          
          
          {/* Default route - Redirects to login or dashboard based on auth status */}
          <Route 
            path="/" 
            element={isAuthenticated() ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />} 
          />

          {/* Protected Routes - Require authentication */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          
          {/* Super Admin Protected Route */}
          <Route
            path="/assign-apps"
            element={
              <ProtectedRoute>
                <SuperAdminRoute>
                  <AssignAppsPage />
                </SuperAdminRoute>
              </ProtectedRoute>
            }
          />

          {/* Optional: 404 Not Found Route - Catches any undefined paths */}
          <Route path="*" element={
            <div style={{ padding: '2rem', textAlign: 'center' }}>
              <h1>404 - Page Not Found</h1>
              <Link to="/">Go Home</Link>
            </div>
          } /> 
        </Routes>
      </div>
    </Router>
  );
}

export default App;